/**
 * Pedidos listos desde cocina: modal, toasts y polling.
 */

function posknReadyAjaxUrl(win) {
	return (
		win.ajaxurl ||
		(win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.ajaxUrl) ||
		'pos-ajax.php'
	);
}

function posknReadyNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function initOrdersReadyPolling(win, $) {
	if (win._posknOrdersReadyPollingBound) return;
	win._posknOrdersReadyPollingBound = true;

	$(() => {
		win.posknPollOrdersReady();
		win.setInterval(() => win.posknPollOrdersReady(), 5000);
	});
}

export function attachOrdersReadyGlobals(win, $) {
	win.poskn_ready_notified_ids = win.poskn_ready_notified_ids || {};
	initOrdersReadyPolling(win, $);

	win.posknShowReadyToast = function posknShowReadyToast(orderId, mesaNumero, mesaNombre) {
		const label = mesaNumero
			? `Mesa ${mesaNumero}${mesaNombre ? ` - ${mesaNombre}` : ''}`
			: `Pedido #${orderId}`;
		const msg = `¡El pedido de ${label} está listo para entregar!`;

		let $container = $('#poskn-ready-toasts');
		if (!$container.length) {
			$container = $(
				'<div id="poskn-ready-toasts" style="position:fixed;top:16px;right:16px;z-index:99999;max-width:380px;"></div>',
			).appendTo('body');
		}

		const $toast = $(
			'<div class="poskn-ready-toast" style="pointer-events:auto;background:#28a745;color:#fff;padding:14px 18px;border-radius:10px;margin-bottom:10px;box-shadow:0 4px 20px rgba(0,0,0,0.25);border:2px solid #1e7e34;font-weight:600;font-size:14px;animation:poskn-toast-in 0.35s ease;"></div>',
		);
		$toast.html(
			`<span style="display:block;margin-bottom:8px;">🔔 ${msg}</span><button type="button" class="poskn-toast-ver" style="width:100%;padding:8px 12px;background:rgba(255,255,255,0.9);color:#1e7e34;border:none;border-radius:6px;cursor:pointer;font-weight:bold;font-size:12px;">Ver pedidos listos</button>`,
		);
		$toast.find('button').on('click', () => {
			win.verPedidosListos();
			$toast.fadeOut(200, function fadeOutToast() {
				$(this).remove();
			});
		});
		$container.append($toast);

		win.setTimeout(() => {
			$toast.fadeOut(300, function fadeOutToastAuto() {
				$(this).remove();
			});
		}, 12000);

		try {
			const pluginUrl = win.posknPluginUrl || '';
			const a = new Audio(`${pluginUrl}assets/sound.mp3`);
			a.volume = 0.6;
			a.play().catch(() => {});
		} catch (e) {
			/* ignore */
		}
	};

	win.posknPollOrdersReady = function posknPollOrdersReady() {
		const tiendaId =
			win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id
				? parseInt(win.posknTiendaSeleccionada.id, 10)
				: win.posknUserTienda && win.posknUserTienda.id
					? parseInt(win.posknUserTienda.id, 10)
					: 0;
		$.ajax({
			url: posknReadyAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_get_orders_ready_for_pickup',
				nonce: posknReadyNonce(win),
				tienda_id: tiendaId || 0,
			},
			dataType: 'json',
			timeout: 8000,
		})
			.done((res) => {
				if (res && res.success && res.data && res.data.orders && res.data.orders.length) {
					res.data.orders.forEach((o) => {
						if (win.poskn_ready_notified_ids[o.order_id]) return;
						win.poskn_ready_notified_ids[o.order_id] = true;
						win.posknShowReadyToast(o.order_id, o.mesa_numero, o.mesa_nombre);
					});
				}
			})
			.fail(() => {});
	};

	win.verPedidosListos = function verPedidosListos() {
		$('#modal-pedidos-listos').css('display', 'flex');

		$('#modal-pedidos-listos')
			.off('click')
			.on('click', function onClickModalListos(e) {
				if ($(e.target).is('#modal-pedidos-listos') && typeof win.cerrarModal === 'function') {
					win.cerrarModal('modal-pedidos-listos');
				}
			});

		$('#pedidos-listos-content').html(`
                <div style="text-align: center; padding: 40px; color: #666;">
                    <div style="font-size: 48px; margin-bottom: 15px;">⏳</div>
                    <p>Cargando pedidos listos...</p>
                </div>
            `);

		const tiendaId =
			win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id
				? parseInt(win.posknTiendaSeleccionada.id, 10)
				: win.posknUserTienda && win.posknUserTienda.id
					? parseInt(win.posknUserTienda.id, 10)
					: 0;
		$.ajax({
			url: posknReadyAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_get_orders_ready_for_pickup',
				nonce: posknReadyNonce(win),
				tienda_id: tiendaId || 0,
			},
			dataType: 'json',
		})
			.done((res) => {
				let pedidos = [];
				if (res && res.success) {
					if (res.data && res.data.orders) {
						pedidos = res.data.orders;
					} else if (res.data && Array.isArray(res.data)) {
						pedidos = res.data;
					}
				}

				if (pedidos && pedidos.length > 0) {
					let html = `
                        <div style="margin-bottom: 16px; padding: 12px; background: #e8f5e9; border-radius: 6px; text-align: center;">
                            <strong style="color: #2e7d32; font-size: 16px;">${pedidos.length} Pedido${pedidos.length > 1 ? 's' : ''} Listo${pedidos.length > 1 ? 's' : ''} para Entregar</strong>
                        </div>
                        <table style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr style="background: #f5f5f5;">
                                    <th style="padding: 12px; text-align: left; border: 1px solid #ddd;">Pedido #</th>
                                    <th style="padding: 12px; text-align: left; border: 1px solid #ddd;">Mesa</th>
                                    <th style="padding: 12px; text-align: center; border: 1px solid #ddd;">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                    `;

					pedidos.forEach((pedido) => {
						const mesaLabel = pedido.mesa_numero
							? `Mesa ${pedido.mesa_numero}${pedido.mesa_nombre ? ` - ${pedido.mesa_nombre}` : ''}`
							: 'Sin mesa';

						html += `
                            <tr style="border-bottom: 1px solid #eee;">
                                <td style="padding: 12px; border: 1px solid #ddd;">
                                    <strong style="color: #2196F3; font-size: 14px;">#${pedido.order_id}</strong>
                                </td>
                                <td style="padding: 12px; border: 1px solid #ddd;">
                                    <span style="font-size: 14px;">${mesaLabel}</span>
                                </td>
                                <td style="padding: 12px; border: 1px solid #ddd; text-align: center;">
                                    <button onclick="marcarPedidoEntregado(${pedido.order_id})" style="background: #4CAF50; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: bold;">
                                        ✅ Marcar Entregado
                                    </button>
                                </td>
                            </tr>
                        `;
					});

					html += `
                            </tbody>
                        </table>
                    `;

					$('#pedidos-listos-content').html(html);
				} else {
					$('#pedidos-listos-content').html(`
                        <div style="text-align: center; padding: 40px; color: #666;">
                            <div style="font-size: 48px; margin-bottom: 15px;">✅</div>
                            <p style="font-size: 16px; margin-bottom: 8px;">No hay pedidos listos en este momento</p>
                            <p style="font-size: 14px; color: #999;">Los pedidos marcados como listos en cocina aparecerán aquí</p>
                        </div>
                    `);
				}
			})
			.fail((xhr, status, error) => {
				console.error('Error al cargar pedidos listos:', error, xhr.responseText);
				$('#pedidos-listos-content').html(`
                    <div style="text-align: center; padding: 40px; color: #f44336;">
                        <div style="font-size: 48px; margin-bottom: 15px;">❌</div>
                        <p>Error al cargar los pedidos listos</p>
                        <p style="font-size: 12px; color: #999;">Error: ${error}</p>
                        <p style="font-size: 11px; color: #999; margin-top: 10px;">${xhr.responseText || 'Sin detalles'}</p>
                    </div>
                `);
			});
	};

	win.marcarPedidoEntregado = function marcarPedidoEntregado(orderId) {
		if (!confirm('¿Marcar este pedido como entregado?')) return;

		$.ajax({
			url: posknReadyAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_mark_order_delivered',
				order_id: orderId,
				nonce: posknReadyNonce(win),
			},
			dataType: 'json',
		})
			.done((res) => {
				if (res && res.success) {
					win.mostrarNotificacion(`Pedido #${orderId} marcado como entregado`, 'success');
					win.verPedidosListos();
				} else {
					win.mostrarNotificacion('Error al marcar como entregado', 'error');
				}
			})
			.fail((xhr, status, error) => {
				console.error('Error al marcar como entregado:', error);
				win.mostrarNotificacion('Error de conexión', 'error');
			});
	};
}
